export const navMenuDrawerSx = (theme) => ({
  bgcolor: theme.palette.primary.main,
  overflow: 'hidden',
});

export const navListSx = (height) => ({
  height: height,
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
});

export const navListItemTextSx = {
  fontSize: '24px  !important',
  fontWeight: 700,
};
